import { ApiHelper } from './apiHelper';
import { DashboardData } from '../components/common/CommonTypes';

export class DashboardApi {
    getDashboardData(
        surname: string,
        postcode: string,
        email: string,
        brandId: number,
        token: string,
        successCallback: (dashboardData: DashboardData) => void,
        failureCallback: () => void,
        signal: AbortSignal
    ): void {
        const dataUrl = `/api/dashboard?email=${email}&postcode=${postcode}&surname=${surname}&brandId=${brandId}`;

        new ApiHelper().getDataSecureAsync(
            dataUrl,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
}
